import React, {useState, useEffect} from 'react';
import '../../../css/pages/accountsettingsedit.scss';
import Cookies from 'js-cookie';
import { useHistory, useParams } from 'react-router-dom';
import APICall from '../../actions/apicall';
import Submit from '../reusable/Submit';
import blackCancelButton from '../../../images/blackCancelButton.png';

function AccountSettingsEdit() {
    const history = useHistory();
    const [fullName, setFullName] = useState('');
    const [emailAddress, setEmailAddress] = useState('');
    const [company, setCompany] = useState('');
    const [title, setTitle] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [address, setAddress] = useState('');
    const [countryCode, setCountryCode] = useState('+1');
    const [doneText, setDoneText] = useState('Save');
    const [showErrorMessage, setShowErrorMessage] = useState(false);
    const [accountErrorText, setAccountErrorText] = useState('');

    let accessToken = Cookies.get('access_token') ?? null;
    let userId = Cookies.get('rs11_user_id') ?? 0;
    
    if (accessToken == null){
        history.push('/map')
    }
    else {
        const token_expires_in = Cookies.get('token_expires_in');
        var time = new Date();
        const current_time = time.toISOString();
        if (current_time > token_expires_in) {
            Cookies.remove('access_token');
            Cookies.remove('token_expires_in');
            Cookies.remove('username');
            history.push('/map')
        }
    }

    useEffect (() => {
        APICall.GetAccountDetails(accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                (response.data.data.email) && setEmailAddress(response.data.data.email);
                (response.data.data.fullname) && setFullName(response.data.data.fullname);
                (response.data.data.phone_number) && setPhoneNumber(response.data.data.phone_number);
                (response.data.data.country_code) && setCountryCode(response.data.data.country_code);
                (response.data.data.company) && setCompany(response.data.data.company);
                (response.data.data.tile) && setTitle(response.data.data.tile);
                (response.data.data.address) && setAddress(response.data.data.address);
            }
        });
    }, []);

    const handleDone = () => {
        setDoneText('Submitting...');
        window.dataLayer.push({'event': 'account_settings_save'});
        let data = {
            email: emailAddress,
            fullname: fullName,
            country_code: countryCode,
            phone_number: phoneNumber,
            company: company,
            tile: title,
            address: address
        }
        APICall.UpdateAccountDetails(data, accessToken, (response) => {
            if (response.status == 200 && response.data.status == 'success') {
                history.push('/account-settings')
            }
            else {
                setShowErrorMessage(true);
                setAccountErrorText(response.data.message);
                setDoneText('Save');
            }
        })
    }


    return (
        <div className='edit-account-settings'>
            <img className='cancel-icon' height='25px' src={blackCancelButton} onClick={() => (history.push('/account-settings'))} />
            <p className='title-text'>Account Settings</p>
            <div className='input-data'>
                <div className='enter-input'>
                   <label className='label-class' for='full-name'>Full Name</label>
                   <input className={fullName != '' ? 'input-field entered' : 'input-field'}
                        placeholder=''
                        id='full-name'
                        value={fullName}
                        onChange={(e) => setFullName(e.target.value)}
                    />
                </div>
                <div className='enter-input'>
                   <label className='label-class' for='email'>Email Address</label>
                   <input className={emailAddress != '' ? 'input-field entered' : 'input-field'}
                        placeholder=''
                        id='email'
                        value={emailAddress}
                        // onChange={(e) => setEmailAddress(e.target.value)}
                    />
                </div>
                <div className='enter-input'>
                   <label className='label-class' for='company'>Company Represented</label>
                   <input className={company != '' ? 'input-field entered' : 'input-field'}
                        placeholder=''
                        id='company'
                        value={company}
                        onChange={(e) => setCompany(e.target.value)}
                    />
                </div>
                <div className='enter-input'>
                   <label className='label-class' for='title'>Title</label>
                   <input className={title != '' ? 'input-field entered' : 'input-field'}
                        placeholder=''
                        id='title'
                        value={title}
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
                <div className='enter-input'>
                   <label className='label-class' for='phone'>Phone Number</label>
                   <div className='phone-number-class'>
                        <input className={countryCode != '' ? 'code-input entered' : 'code-input'}
                            placeholder=''
                            id='phone'
                            value={countryCode}
                            onChange={(e) => setCountryCode(e.target.value)}
                        />
                        <input className={phoneNumber != '' ? 'input-field entered' : 'input-field'}
                            placeholder=''
                            id='code-number'
                            value={phoneNumber}
                            onChange={(e) => setPhoneNumber(e.target.value)}
                        />
                   </div>
                </div>
                <div className='enter-input'>
                   <label className='label-class'>Address</label>
                   <input className={address != '' ? 'input-field entered' : 'input-field'}
                        placeholder=''
                        id='user-address'
                        value={address}
                        onChange={(e) => setAddress(e.target.value)}
                    />
                </div>
                {
                    (showErrorMessage) && (
                    <p className='error-text'>{accountErrorText}</p>)
                }
            </div>
            <Submit actionText={doneText} callFunction={handleDone} disable={doneText != 'Save' && true} />
        </div>
    )

}
export default AccountSettingsEdit;